import { Box, Button, Grid2 } from '@mui/material';
import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { insuranceSelector } from '../../../model';
import { useSelector } from 'react-redux';
import { InsuranceBrokerDetailsRow } from './InsuranceBrokerDetailsRow';
import { formatCurrency } from 'utils';
import moment from 'moment';

export const InsuranceBrokerDetails = () => {
  const { handleOpen: handleOpenInsuranceBrokerDialog } = useModal(ModalsKeys.InsuranceAddEditBrokerDialog);

  const insuranceBroker = useSelector(insuranceSelector.insuranceBroker)!;

  return (
    <Box>
      <Button size="small" color="primary" onClick={() => handleOpenInsuranceBrokerDialog()}>
        Edit Details
      </Button>
      <Grid2 container spacing={2} mt={2}>
        <Grid2 container size={6}>
          <InsuranceBrokerDetailsRow label="Insurance Company" value={insuranceBroker.companyName} />
          <InsuranceBrokerDetailsRow label="Agent Name" value={insuranceBroker.contactName} />
          <InsuranceBrokerDetailsRow label="Contact Email" value={insuranceBroker.contactEmail} />
          <InsuranceBrokerDetailsRow label="Phone Number" value={insuranceBroker.contactPhone} />
        </Grid2>
        <Grid2 container size={6}>
          <InsuranceBrokerDetailsRow
            label="Policy Renewal Date"
            value={insuranceBroker.renewalDate}
            formatter={value => (value ? moment(value).format('ll') : '')}
          />
          <InsuranceBrokerDetailsRow
            label="Physical Damage Deductible"
            value={insuranceBroker.physicalDamageDeduction}
            formatter={formatCurrency}
          />
          <InsuranceBrokerDetailsRow
            label="Liability Coverage"
            value={insuranceBroker.liabilityCoverage}
            formatter={formatCurrency}
          />
          <InsuranceBrokerDetailsRow label="Policy Type" value={insuranceBroker.productType} />
        </Grid2>
      </Grid2>
    </Box>
  );
};
